import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../translate';
import PaymentMethods from './PaymentMethods';
import StripeCardProp from '../../../sections/profile/propTypes/StripeCardProp';
import PriceProp from '../../propTypes/priceProp';
import ImageProp from '../../propTypes/imageProp';
import AddressProp from '../../propTypes/addressProp';
import VatTypesProp from '../../forms/Address/VatTypesProp';
import TenantProp from '../../propTypes/tenantProp';
import PaymentCouponSection from '../../shop/PaymentCouponSection';
import CouponProp from '../../../sections/shop/propTypes/couponProp';

const CheckoutPayment = ({
    t,
    vatTypes,
    tenant,
    companyBilling,
    checkoutDetail,
    cards,
    updatePaymentMethod,
    tabActive,
    accountHolderName,
    selectedCreditCard,
    handleIsLoading,
    couponInserted,
    updateCoupon,
    selectedCoupon,
    coupons,
    orderAlreadyCreated,
}) => (
    <>
      <div className="academy-payment-coupons">
        <PaymentCouponSection
          t={t}
          coupons={coupons}
          selectedCoupon={selectedCoupon}
          couponInserted={couponInserted}
          updateCoupon={updateCoupon}
          orderAlreadyCreated={orderAlreadyCreated}
          wrapperClass="remove-padding-col"
          couponListClass="coupon-list-container"
        />
      </div>
      <div className="academy-payment-methods col-12 no-padding">
        {checkoutDetail.total > 0 ? (
          <PaymentMethods
            t={t}
            cards={cards}
            updatePaymentMethod={updatePaymentMethod}
            tabActive={tabActive}
            accountHolderName={accountHolderName}
            selectedCreditCard={selectedCreditCard}
            handleIsLoading={handleIsLoading}
            tenant={tenant}
            vatTypes={vatTypes}
            companyBilling={companyBilling}
            isAcademy
          />
        ) : (
          <>
            <h3>{t('shop.checkout.payment.notRequired')}</h3>
            <hr />
          </>
        )}
      </div>
    </>
  );

CheckoutPayment.propTypes = {
  t: PropTypes.func.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
  updatePaymentMethod: PropTypes.func.isRequired,
  tabActive: PropTypes.string.isRequired,
  accountHolderName: PropTypes.string,
  selectedCreditCard: PropTypes.string,
  item: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    userPrice: PropTypes.shape(PriceProp.PropTypes),
    userPromotionPrice: PropTypes.shape(PriceProp.PropTypes),
    name: PropTypes.string.isRequired,
    image: PropTypes.shape(ImageProp.propType).isRequired,
  }).isRequired,
  handleIsLoading: PropTypes.func.isRequired,
  checkoutDetail: PropTypes.shape({
    isPaidWithCoins: PropTypes.bool.isRequired,
    total: PropTypes.number.isRequired,
    item: PropTypes.shape({
      tax: PropTypes.number,
      total: PropTypes.number,
      price: PropTypes.number,
    }),
  }).isRequired,
  vatTypes: PropTypes.arrayOf(PropTypes.shape(VatTypesProp.propType))
    .isRequired,
  tenant: PropTypes.shape(TenantProp.propType).isRequired,
  companyBilling: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    taxCode: PropTypes.string,
    taxType: PropTypes.string,
    vatNumber: PropTypes.string,
    address: PropTypes.shape(AddressProp.propType),
  }),
  couponInserted: PropTypes.string,
  updateCoupon: PropTypes.func.isRequired,
  selectedCoupon: PropTypes.string,
  coupons: PropTypes.arrayOf(PropTypes.shape(CouponProp.propType)).isRequired,
  orderAlreadyCreated: PropTypes.string,
};
CheckoutPayment.defaultProps = {
  accountHolderName: '',
  selectedCreditCard: '',
  companyBilling: null,
  orderAlreadyCreated: null,
  selectedCoupon: '',
  couponInserted: '',
};

export default translate(CheckoutPayment);
